<template>
</template>

<script>
	export default {
		props: {
			session: String,
			path: String
		},

		mounted() {
			if (this.path.includes('/agreement')) {
				this.redirectTo({
					path: this.path
				});
				return;
			}
			this.$store.commit('setSession', this.session);
			this.$store.dispatch('updateLoginInfo', () => {
				let query = this.query2Json();
				delete query.sa;
				delete query.session;
				delete query.path;

				if (query.workType) {
					localStorage.setItem(query.workType, JSON.stringify({
						v: query.viewId,
						g: query.groupId,
						k: ''
					}));
				}
				delete query.workType;
				delete query.viewId;
				delete query.groupId;

				if (query._from) {
					window._fromRoute = query._from;
				}
				delete query._from;

				this.redirectTo({
					path: this.path,
					query
				});
			});
		},

		methods: {
			query2Json() {
				let result = {}, searchStr = location.search.replace(/^\?/, '');
				if (!searchStr) return result;
				searchStr.split('&').forEach(item => {
					let [key, value = ''] = item.split('=');
					if (key) {
						result[decodeURIComponent(key)] = decodeURIComponent(value);
					}
				});
				return result;
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>